import { Component, OnInit, inject } from '@angular/core';
import { SecondaryButtonComponent } from '../../../../../shared/components/secondary-button/secondary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { HrisIntegrationDataService } from '../../services/hris-integration-data.service';

@Component({
  selector: 'app-hris-integration-setup-button',
  imports: [SecondaryButtonComponent, TranslocoPipe],
  templateUrl: './hris-integration-setup-button.component.html',
})
export class HrisIntegrationSetupButtonComponent implements OnInit {
  protected readonly hrisIntegrationDataService = inject(
    HrisIntegrationDataService,
  );

  async handleButtonClick() {
    await this.hrisIntegrationDataService.openHRISIntegrationDialog();
  }
  ngOnInit(): void {
    this.hrisIntegrationDataService.observeUrlAndSendIntegration();
  }
}
